import { FunctionComponent, ReactElement } from 'react';
import { IFormatsSectionTileListProps } from 'typings/IFormatsSectionTileListProps';
import { FormatsSectionStyle, FormatsSectionTitleStyle } from '../FormatAToZ.style';
import PortraitItem from '../../PortraitItem';
import { TileListStyle } from '../../Lists/TileList/TileList.style';
import { FormatsSectionPosterWrapperStyle } from './FormatsSectionTileList.style';

const FormatsSectionTileList: FunctionComponent<IFormatsSectionTileListProps> = ({ filter, formats }): ReactElement => (
  <FormatsSectionStyle data-testid="formatsSectionTileList">
    <FormatsSectionTitleStyle>{filter}</FormatsSectionTitleStyle>
    <TileListStyle>
      {(formats || []).map(format => (
        <FormatsSectionPosterWrapperStyle key={format.guid}>
          <PortraitItem program={format} />
        </FormatsSectionPosterWrapperStyle>
      ))}
    </TileListStyle>
  </FormatsSectionStyle>
);

export default FormatsSectionTileList;
